import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { InsuranceId } from '@gearghost/api-schemas/cart'

/**
 * Cart coverage slice — stores the per-vendor insurance selection the
 * renter has picked during checkout. Cleared when the order lands (see
 * clearVendorCoverage usage in orders flow). `coverageType` carries the
 * shared insuranceId wire value and is typed AS that enum on purpose —
 * the loose `string` coupling this replaced is exactly how mobile
 * drifted into sending '' for Third Party and skipping the backend's
 * third-party gates.
 */
type VendorCoverageEntry = {
  coverageType: InsuranceId;
  insuranceAgreement: boolean;
};

type CartCoverageState = {
  vendorCoverage: Record<string, VendorCoverageEntry>;
};

type SetVendorCoveragePayload = VendorCoverageEntry & { vendorId: string };

const initialState: CartCoverageState = {
  vendorCoverage: {},
};

const cartCoverageSlice = createSlice({
  name: 'cartCoverage',
  initialState,
  reducers: {
    setVendorCoverage(state, action: PayloadAction<SetVendorCoveragePayload>) {
      const { vendorId, coverageType, insuranceAgreement } = action.payload
      state.vendorCoverage[vendorId] = { coverageType, insuranceAgreement }
    },
    clearVendorCoverage(state, action: PayloadAction<string>) {
      delete state.vendorCoverage[action.payload]
    },
    clearCoverage() {
      return { vendorCoverage: {} }
    }
  }
})

export const { setVendorCoverage, clearVendorCoverage, clearCoverage } = cartCoverageSlice.actions
export default cartCoverageSlice.reducer
